import {
  useCalendarDetail,
  useSetRepairersActivity,
} from 'app/core/api/company/api-company';
import {
  CalendarData,
  PageDetails,
} from 'app/core/api/company/api-company.types';
// import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import styledFuncs from 'app/styles/styledFuncs';
import {
  useUrlParams,
  useWatchAsRef,
  useEffectOnce,
} from 'app/tools/hooks/misc-hooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Geocode, { GeocodeCoords } from 'react-geocode';
import { appEnv } from 'app/core/environment';
import SimpleMapView from 'app/shared/components/google-map/SimpleMapView';
import moment from 'moment';
import AppImage from 'app/shared/components/app-image/AppImage';
import { DefaultUserImg } from 'app/shared/components/misc';

const LinkButton = styled.div`
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  display: block;
  margin: 10px !important;
  padding: 10px 45px 10px 45px;
  color: black;
  b {
    font-size: 13px;
    font-weight: bold;
    display: block;
    color: black;
  }
  text {
    font-size: 12px;
    color: black;
  }
  .timeAllocatedBlock {
    padding: 10px 0px 10px 10px;
  }
  .timeAllocatedBlock div {
    display: flex;
  }
  .timeAllocatedBlock span {
    width: 20%;
  }
  .timeAllocatedBlock hr,
  .timeAllocatedBlock p {
    width: 80%;
  }
  .timeAllocatedBlock hr {
    background-color: lightgray;
    height: 3px;
    border-radius: 10%;
  }
  .timeAllocatedBlock p {
    background-color: rgba(106, 188, 53, 0.6);
    margin: 5px;
    padding: 10px 10px;
    border-radius: 10px;
  }
`;
const UserButton = styled.div`
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  display: block;
  margin: 10px !important;
  padding: 10px 45px 10px 10px;
  color: black;
  b {
    font-size: 13px;
    font-weight: bold;
    display: block;
    color: black;
  }
  text {
    font-size: 12px;
    color: black;
  }
`;

export default function BusinessCalendarEventDetail(): JSX.Element {
  const { id } = useUrlParams(['id']);
  Geocode.setApiKey(appEnv.GOOGLE_API_KEY);
  const [data, setData] = useState<CalendarData>();
  const [prevTime, SetPrevTime] = useState('9:00');
  const [nextTime, SetNextTime] = useState('11:00');

  const { request$: repairActivity } = useSetRepairersActivity();
  useEffectOnce(() => {
    const pageDetails: PageDetails = {
      pagename: 'Calendar Event Detail',
    };
    repairActivity(pageDetails).subscribe();
  });
  const [addressGeocode, setAddressGeocode] =
    useState<GeocodeCoords>();
  const {
    resource: calendarData,
    loading,
    request,
    // loadingMissing: loadingMissingCompany,
  } = useCalendarDetail(id);
  const loadingRef = useWatchAsRef(loading);
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request]);
  useEffect(() => {
    if (calendarData && calendarData.length > 0) {
      setData(calendarData[0]);
      if (calendarData[0]?.time) {
        SetNextTime(
          moment(calendarData[0]?.time, 'HH-mm')
            .add(1, 'hours')
            .format('HH:mm')
        );
        SetPrevTime(
          moment(calendarData[0]?.time, 'HH-mm')
            .add(-1, 'hours')
            .format('HH:mm')
        );
      }

      if (calendarData[0].userDetails.address) {
        Geocode.fromAddress('Udaipur').then(
          response => {
            const { lat, lng } =
              response.results[0].geometry.location;
            setAddressGeocode({ lat, lng } as GeocodeCoords);
          },
          error => {
            console.error(error);
          }
        );
      }
    }
  }, [calendarData]);
  return (
    <>
      <>
        <h3 style={{ color: '#31AD31', fontWeight: 'normal' }}>
          User Details
        </h3>
        <UserButton color="default">
          <AppImage
            alt="profile image"
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            src={data?.userDetails.userProfilePhoto}
            fallbackImgNode={<DefaultUserImg size={60} />}
            height="60px"
            noPad
            className="mb-1.5 w-10 h-10 rounded"
          />
          <div style={{ marginLeft: '100px', marginTop: '-110px' }}>
            <b>{data?.deliveryType}</b>
            {data?.customerName}
            <br />
            <text>{data?.date}</text>
            <br />
            <text>{data?.time}</text>
          </div>
        </UserButton>
        <h3 style={{ color: '#31AD31', fontWeight: 'normal' }}>
          Details
        </h3>
        <LinkButton color="default">
          <div>
            <b style={{ fontWeight: 500 }}>Item Details</b>
            <div style={{ paddingLeft: '11px' }}>
              <text>
                Product Name: {data?.itemDetails.productName}
              </text>
              <br />
              <text>Issue Type: {data?.itemDetails.issueType}</text>
            </div>
          </div>
        </LinkButton>
        <LinkButton color="default">
          <div>
            <b style={{ fontWeight: 500 }}>Time Allocated</b>
            <text>
              {data?.date} {data?.time}
            </text>
          </div>
          {data?.time && (
            <div className="timeAllocatedBlock">
              <div>
                <span>{prevTime}</span>
                <hr />
              </div>
              <div>
                <span style={{ paddingTop: '15px' }}>
                  {data?.time}
                </span>
                <p>You drop off</p>
              </div>
              <div>
                <span>{nextTime}</span>
                <hr />
              </div>
            </div>
          )}
        </LinkButton>
        <LinkButton color="default">
          <div>
            <b style={{ fontWeight: 500 }}>Location</b>
            {addressGeocode && (
              <SimpleMapView currentLocation={addressGeocode} />
            )}
          </div>
        </LinkButton>
      </>
    </>
  );
}
